import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.css'],
    standalone: false
})

export class BreadcrumbComponent implements OnInit {

    environment = environment;

    @Input()
    breadcrumb: any;

    @Input()
    brand: string;

    ngOnInit() {}
}
